module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABFCAMAAAArU9sbAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA8UExURQAAANra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2ojFLLAAAAATdFJOUwAgJsZJ0ysiLQIe+b3awtnzH8UznA/kAAAAeElEQVRYw+3YywqAIBSE4VHLvJXVef93jWqfiyNUMP9aPgRxM0AjW9ZioW0UkVGLJDlLSiVcSqBChQoVKlSovKJEMz00XMrwdMREwFfRVj120eeQOygZrstd/KxGZt/pjfgDqFChQoUKld8q9/6yfWILgl3y0tylDmrLNyticLwLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add.png
// module id = QBcd
// module chunks = 1